// extracted by mini-css-extract-plugin
export default {"imagen":"Header_imagen__eWWBf","contenedor":"Header_contenedor__dE4Fs","item":"Header_item__IvEBm"};